import { render, staticRenderFns } from "./Digipost.vue?vue&type=template&id=802592a2&scoped=true&"
import script from "./Digipost.vue?vue&type=script&lang=js&"
export * from "./Digipost.vue?vue&type=script&lang=js&"
import style0 from "./Digipost.vue?vue&type=style&index=0&id=802592a2&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "802592a2",
  null
  
)

export default component.exports